import React, { Component } from 'react';
import { Fragment } from 'react'; // So it doesn't create a unnecessary node element. **Only available in react 16+

import { Anchorme } from 'react-anchorme'
import ScaleText from "react-scale-text";
export class Bubble extends Component {


  constructor(props) {
    super(props);

    this.doClickAction = this.doClickAction.bind(this);
    this.doDoubleClickAction = this.doDoubleClickAction.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
      this.onDislike = this.onDislike.bind(this);
      this.onDoubleClick = this.onDoubleClick.bind(this);
      this.onDelete = this.onDelete.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.state = { isLiked: this.props.mylikes > this.props.mydislikes, isDisliked: this.props.mylikes < this.props.mydislikes };
  }

   timer = 0;
   delay = 200;
   prevent = false;

  doClickAction() {
    console.log('Click')
    this.props.unselectAll();
   if (!this.props.opened)
  {
      this.props.selectBubble(this.props.id);
  }
}
  doDoubleClickAction(e) {
    console.log('Double Click')
    this.onLike(e)
  }
  handleClick() {
    let me = this;
    this.timer = setTimeout(function() {
      if (!me.prevent) {
        me.doClickAction();
      }
      me.prevent = false;
    }, this.delay);
  }
  handleDoubleClick(){
    clearTimeout(this.timer);
    this.prevent = true;
    this.doDoubleClickAction();
  }


  handleTouchMove(e){

    if ( this.props.onTouchMove)(this.props.onTouchMove(e,this));
  }

    toggleClass(cls, e) {
        if (e.target.classList.contains(cls)) {
            e.target.classList.remove(cls);
        }
        else {
            e.target.classList.add(cls);
        }
    }
    onLike(e) {
        
        if (this.props.onLikeHandler) this.props.onLikeHandler(this.props.id,this);

        this.setState({ isLiked: true });
        this.setState({ isDisliked: false });

    }
    onDislike(e) {

        
        e.stopPropagation();  //  <------ Here is the magic
        if (this.props.onLikeHandler) this.props.onDislikeHandler(this.props.id,this);

        this.setState({ isLiked: false });
        this.setState({ isDisliked: true });

    }

    onDelete(e) {

        e.stopPropagation();  //  <------ Here is the magic
        if (this.props.onDeleteHandler) this.props.onDeleteHandler(this.props.id,this);
      

    }
    onDoubleClick() {
        this.props.unselectAll();
    }
   

    render() {

        var containerStyle = {};
        var blurSize=this.props.opened?"1px":this.props.blur_size + 'px)';
        
        containerStyle = {

            'left': this.props.bubble_pos + "%",
            '-webkit-filter': {blurSize},
            '-moz-filter': {blurSize},
            'filter': {blurSize},
            '-webkit-animation-duration': this.props.animation_delay + 's',
            '-moz-animation-duration': this.props.animation_delay + 's',
            'animation-duration': this.props.animation_delay + 's',
            'animation-fill-mode': 'forwards',
            'animation-play-state': this.props.opened ? 'paused' : 'running',
        'z-index':this.props.opened?999:1


        };
    
        
        var scale =  (this.props.opened)?"1":String(this.props.bubble_size/200.0);
        var scalestr="1";
        var bubbleStyle = {};
        if (this.props.opened) {
            bubbleStyle = {

                'scale':'1',
                'left': '50%',
                'width': '201px',
                'height': '201px',
                'text-align': 'center',
                'vertical-align': 'middle',
                '-webkit-filter': 'blur(' + 0 + 'px)',
                '-moz-filter': 'blur(' +0 + 'px)',
                'filter': 'blur(' + 0 + 'px)',
                 
                 'animation-play-state': 'paused'
            };
        }
        else {
            bubbleStyle = {
                'scale': scale,
                'width': '200px',
                'height': '200px',
                'text-align': 'center',
                'vertical-align': 'middle',
                'animation-play-state': 'running'
            };
        }

        var bubbleClass = "bubble";
        if (this.props.opened) bubbleClass = "bubble";
        return (
            <div className="bubble-container paragraph parent" style={containerStyle}>
                
                <div id={"bubble_"+this.props.id} className={bubbleClass} style={bubbleStyle} onClick={this.handleClick} onDoubleClick={this.handleDoubleClick} onTouchMove={this.handleTouchMove} >
                {this.props.isNew && <div style ={{ 'position': 'absolute', 'top': '0px', 'display': 'flex',color:"Yellow" }}>
                    <span class="material-symbols-outlined">grade</span>
                    </div>
                }
                {this.props.opened && <div style ={{ 'position': 'absolute', 'top': '0px', 'display': 'flex' }}>
                        
                        { <div className="wrapper" >
                            <div className={"is-active"}  onClickCapture={(e) => this.onDislike(e)} >
                                <i className="material-icons is-liked bouncy paragraph">thumb_down</i>
                                <span className="like-overlay"></span>
                            </div>
                            -{this.props.dislikes}
                        </div>
                        }
                        {<div className="wrapper" >
                            <div className={"is-active"} onClickCapture={(e) => this.onLike(e)}>
                            {this.props.mylikes>0?<i className="material-icons is-liked bouncy paragraph" color="Red">favorite</i>:
                            <i className="material-icons is-liked bouncy paragraph">favorite</i>}
                                <span className="like-overlay"></span>
                            
                            </div>
                            +{this.props.likes}
                        </div>
                        }
                    </div>
                    }
                    {this.props.opened && <div> 
                        <ScaleText>
                            <Anchorme className="child" target="_blank" rel="noreferrer noopener">{this.props.text}</Anchorme> 
                        </ScaleText>
                    </div>}
                    {this.props.opened && <div className="wrapper fadeitin" style={{ 'position': 'absolute', 'bottom': '0px', 'display': 'flex' }} >
                        {this.props.userId != "" && 
                        <div className={" is-active"} onClickCapture={(e) => this.onDelete(e)}>
                            
                            <i className="material-icons is-liked bouncy paragraph">delete</i>
                            <span className="like-overlay"></span>
                        
                        </div>
                        }
                    </div>
                        
                    }
                </div>
            </div>
        );
  }
}
